/* ML Fit & feel: native modal focus handling, Escape, backdrop and no-JS disclosure. */
(() => {
  if (customElements.get('ml-fit-feel')) return;
  class MlFitFeel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.disclosure = this.querySelector('details');
      this.trigger = this.querySelector('summary');
      this.content = this.querySelector('[data-ml-fit-content]');
      this.dialog = this.querySelector('dialog');
      if (!this.dialog?.showModal || !this.trigger || !this.content) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const wasExpanded = this.disclosure.open;
      this.querySelector('[data-ml-fit-slot]').append(this.content);
      this.disclosure.open = false;
      this.trigger.setAttribute('role', 'button');
      this.trigger.setAttribute('aria-haspopup', 'dialog');
      this.trigger.setAttribute('aria-controls', this.dialog.id);
      this.trigger.setAttribute('aria-expanded', 'false');
      const openPanel = () => {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('ml-fit-open');
        this.dispatchEvent(new CustomEvent('ml:fit-open', { bubbles: true, detail: { productHandle: this.dataset.productHandle } }));
      };
      this.trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openPanel();
      }, options);
      this.trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        openPanel();
      }, options);
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        this.dialog.close();
      }, options);
      this.querySelector('[data-ml-fit-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        this.trigger.setAttribute('aria-expanded', 'false');
        if (!document.querySelector('.ml-fit-feel__dialog[open]')) document.documentElement.classList.remove('ml-fit-open');
        if (this.isConnected) this.trigger.focus({ preventScroll: true });
      }, options);
      this.querySelector('[data-ml-fit-size]')?.addEventListener('click', (event) => {
        const id = event.currentTarget.dataset.guideId;
        const guide = document.getElementById(id);
        if (!guide?.showModal) return;
        event.preventDefault();
        this.dialog.close();
        requestAnimationFrame(() => {
          if (!guide.open && guide.isConnected) guide.showModal();
        });
      }, options);
      this.dataset.enhanced = 'true';
      if (wasExpanded) openPanel();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
      if (this.content && this.disclosure) this.disclosure.append(this.content);
      if (!document.querySelector('.ml-fit-feel__dialog[open]')) document.documentElement.classList.remove('ml-fit-open');
    }
  }
  customElements.define('ml-fit-feel', MlFitFeel);
})();
